__turbopack_context__.v({
  "actions": "finishing-module__eKN7Sa__actions",
  "breadcrumb": "finishing-module__eKN7Sa__breadcrumb",
  "compareButton": "finishing-module__eKN7Sa__compareButton",
  "container": "finishing-module__eKN7Sa__container",
  "costControls": "finishing-module__eKN7Sa__costControls",
  "costFootnote": "finishing-module__eKN7Sa__costFootnote",
  "costPanel": "finishing-module__eKN7Sa__costPanel",
  "costTotal": "finishing-module__eKN7Sa__costTotal",
  "editorialList": "finishing-module__eKN7Sa__editorialList",
  "extensionTrack": "finishing-module__eKN7Sa__extensionTrack",
  "eyebrow": "finishing-module__eKN7Sa__eyebrow",
  "faqLayout": "finishing-module__eKN7Sa__faqLayout",
  "faqSection": "finishing-module__eKN7Sa__faqSection",
  "film": "finishing-module__eKN7Sa__film",
  "filmLabel": "finishing-module__eKN7Sa__filmLabel",
  "filmMedia": "finishing-module__eKN7Sa__filmMedia",
  "finalCta": "finishing-module__eKN7Sa__finalCta",
  "finePrint": "finishing-module__eKN7Sa__finePrint",
  "header": "finishing-module__eKN7Sa__header",
  "hero": "finishing-module__eKN7Sa__hero",
  "heroCopy": "finishing-module__eKN7Sa__heroCopy",
  "heroTitle": "finishing-module__eKN7Sa__heroTitle",
  "heroVisual": "finishing-module__eKN7Sa__heroVisual",
  "intro": "finishing-module__eKN7Sa__intro",
  "lead": "finishing-module__eKN7Sa__lead",
  "liveDot": "finishing-module__eKN7Sa__liveDot",
  "modelFacts": "finishing-module__eKN7Sa__modelFacts",
  "modelList": "finishing-module__eKN7Sa__modelList",
  "modelName": "finishing-module__eKN7Sa__modelName",
  "modelNumber": "finishing-module__eKN7Sa__modelNumber",
  "modelRow": "finishing-module__eKN7Sa__modelRow",
  "modelTag": "finishing-module__eKN7Sa__modelTag",
  "modelsSection": "finishing-module__eKN7Sa__modelsSection",
  "nativeDetails": "finishing-module__eKN7Sa__nativeDetails",
  "nativeMark": "finishing-module__eKN7Sa__nativeMark",
  "nativeSection": "finishing-module__eKN7Sa__nativeSection",
  "number": "finishing-module__eKN7Sa__number",
  "originalTrack": "finishing-module__eKN7Sa__originalTrack",
  "page": "finishing-module__eKN7Sa__page",
  "play": "finishing-module__eKN7Sa__play",
  "previewIndex": "finishing-module__eKN7Sa__previewIndex",
  "previewTop": "finishing-module__eKN7Sa__previewTop",
  "primary": "finishing-module__eKN7Sa__primary",
  "promiseBand": "finishing-module__eKN7Sa__promiseBand",
  "related": "finishing-module__eKN7Sa__related",
  "resolutionStrip": "finishing-module__eKN7Sa__resolutionStrip",
  "sectionHeading": "finishing-module__eKN7Sa__sectionHeading",
  "selectedRow": "finishing-module__eKN7Sa__selectedRow",
  "skip": "finishing-module__eKN7Sa__skip",
  "stepNumber": "finishing-module__eKN7Sa__stepNumber",
  "steps": "finishing-module__eKN7Sa__steps",
  "textLink": "finishing-module__eKN7Sa__textLink",
  "timeline": "finishing-module__eKN7Sa__timeline",
  "timelineLabels": "finishing-module__eKN7Sa__timelineLabels",
  "timelineTrack": "finishing-module__eKN7Sa__timelineTrack",
  "visualNote": "finishing-module__eKN7Sa__visualNote",
});
